import React from 'react';

const Camera = ({ fill }) => {
    const viewBoxValues = '0 0 512 512';

    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            className="camera"
            viewBox={viewBoxValues}
            style={{ position: 'absolute' }}
        >
            <g>
                <g>
                    <path
                        d="M437.333,117.333h-64c-4.587,0-8.661-2.923-10.112-7.296l-6.741-20.224c-7.275-21.824-27.605-36.48-50.603-36.48h-99.755
			c-22.997,0-43.328,14.656-50.581,36.459l-6.741,20.245c-1.472,4.373-5.547,7.296-10.133,7.296h-64C33.493,117.333,0,150.827,0,192
			v192c0,41.173,33.493,74.667,74.667,74.667h362.667C478.507,458.667,512,425.173,512,384V192
			C512,150.827,478.507,117.333,437.333,117.333z M490.667,384c0,29.397-23.936,53.333-53.333,53.333H74.667
			c-29.397,0-53.333-23.936-53.333-53.333V192c0-29.397,23.936-53.333,53.333-53.333h64c13.781,0,25.984-8.789,30.357-21.867
			l6.763-20.267c4.352-13.077,16.555-21.867,30.336-21.867h99.755c13.781,0,25.984,8.789,30.357,21.888l6.741,20.245
			c4.373,13.077,16.576,21.867,30.357,21.867h64c29.397,0,53.333,23.936,53.333,53.333V384z"
                        fill={fill}
                    />
                </g>
            </g>
            <g>
                <g>
                    <path
                        d="M256,160c-70.592,0-128,57.408-128,128s57.408,128,128,128s128-57.408,128-128S326.592,160,256,160z M256,394.667
			c-58.816,0-106.667-47.851-106.667-106.667c0-58.816,47.851-106.667,106.667-106.667S362.667,229.184,362.667,288
			C362.667,346.816,314.816,394.667,256,394.667z"
                        fill={fill}
                    />
                </g>
            </g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
            <g></g>
        </svg>
    );
};

export default Camera;
